<div
  class="my-20 bg-white rounded-xl lg:flex justify-between xl:py-0">
  <div class="w-full max-w-full lg:max-w-xl xl:max-w-3xl col-span-1 p-8 md:p-16 xl:p-24">
    <h2
      class="font-bold mb-4 text-4xl leading-tight text-bleuCaliceo-300">{{ 'cseContactDescription' | translate }}
    </h2>
    @if (!siteService.center()) {
      <p class="font-semibold text-gray-500 text-md mt-12">{{ 'yourCenterMessage' | translate }}</p>
      <!-- Center Choice -->
      <div appAutoClose="always" class="relative mt-6 mb-12">
        <button class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                type="button">
            <span class="flex items-center">
              <div class="w-12">
              <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60" ngSrc="assets/icons/gray/location.svg"
                   width="60">
              </div>
              <span
                class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                {{ selectionService.center()?.name ?? ('caliceoCenterChoice'|translate) }}
              </span>
            </span>
          <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                     <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
            </span>
        </button>
        <ul
          class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          role="listbox" tabindex="-1">
          @for (center of centerService.centers(); track center.id) {
            <li (click)="selectCenter(center)"
                (keyup.enter)="emulateClick($event)"
                [attr.aria-selected]="selectionService.center()?.id === center.id"
                class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                role="option"
                tabindex="0">
              <div class="flex items-center">
                <span [ngClass]="selectionService.center()?.id === center.id ? 'font-semibold' : 'font-normal'"
                      class="text-lg text-gray-500 ml-3 block truncate">
                  {{ center.name }} @if (center.city; as city) {
                  - {{ city }}
                }
                </span>
              </div>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <form [formGroup]="form" class="w-full max-w-full lg:max-w-4xl col-span-1 p-8 md:p-16 xl:p-24">
    <div class="flex md:flex-row flex-col gap-4 mb-4">
      <div class="w-full md:w-1/2 mb-6 md:mb-0">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="grid-first-name">
          {{ 'firstName' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          formControlName="firstName"
          id="grid-first-name" type="text">
      </div>
      <div class="w-full md:w-1/2">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="grid-last-name">
          {{ 'lastName' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="lastName"
          id="grid-last-name" type="text">
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-entity">
          {{ 'cseEntity' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="entity"
          id="your-entity" type="text">
      </div>
    </div>

    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="employees-number">
          {{ 'employeesNumber' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="number"
          id="employees-number" type="number">
      </div>
    </div>

    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-email">
          {{ 'yourEmail' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="email"
          id="your-email" type="email">
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <app-tel-input formControlName="phone"/>
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="address">
          {{ 'address' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="address"
          id="address" type="text">
      </div>
    </div>
    <div class="flex md:flex-row flex-col gap-4 mb-4">
      <div class="w-full md:w-1/2 mb-6 md:mb-0">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="zip">
          {{ 'zip' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          formControlName="zip"
          id="zip" type="text">
      </div>
      <div class="w-full md:w-1/2">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="city">
          {{ 'city' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="city"
          id="city" type="text">
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-message">
          {{ 'yourMessage' | translate }} <span class="text-red-600">*</span>
        </label>
        <textarea
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          formControlName="message"
          id="your-message"
          rows="5"></textarea>
      </div>
    </div>
    <div class="flex items-center">
      <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
      <button (click)="acceptTerms = !acceptTerms" [ngClass]="acceptTerms ? 'bg-bleuCaliceo-300' : 'bg-gray-200'"
              aria-checked="false"
              aria-labelledby="annual-billing-label"
              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
              role="switch" type="button">
            <span [ngClass]="acceptTerms ? 'translate-x-5' : 'translate-x-0'"
                  aria-hidden="true"
                  class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
      </button>
      <span class="ml-3 text-sm" id="annual-billing-label">
           <span class="font-medium text-gray-500">{{ 'acceptTerms' | translate }}</span> <span
        class="text-red-600">*</span>
          </span>
    </div>
    <p class="mt-10 text-rougeCaliceo-300">* {{ 'requiredInformation' | translate }}</p>
    <button [appProgressClick]="submit"
            [disabled]="form.invalid"
            appHoverGradient
            class="big-btn"
            type="button">
      {{ 'send' | translate }}
    </button>

  </form>
</div>
